<template>
  <div id="app">
    <div class="p-3">
      <VueCronEditorBootstrap v-model="sample1CronExpression" preserve-state-on-switch-to-advanced />
      <b-form-input v-model="sample1CronExpression" readonly />
    </div>
  </div>
</template>

<script>
import VueCronEditorBootstrap from './VueCronEditorBootstrap.vue'
import { BFormInput } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

export default {
  name: 'App',

  components: {
    VueCronEditorBootstrap,
    BFormInput,
  },

  data: () => ({
    sample1CronExpression: '4 4 * * 0,2,3,5',
  }),
}
</script>
